import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery, setError } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { Feature, setFeatureDataList } from '@edikk-edikk/feature';
import { ApiError, HEADER_X_LANGUAGE, NetworkServiceInterface } from '@edikk-edikk/network-service';
import { COOKIE_REQUEST_ID, Cookies } from '@edikk-edikk/cookies';
import { InitResponseType } from '#base/api/types/InitResponseType';
import { API_BASE_NAME, BASE_LOAD_URL } from '#base/constants';
import { DI_CONTAINER_TYPE } from '#srcJs/di-container';

const getApiBase = (diContainer: Container) => createApi({
  reducerPath: API_BASE_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    init: builder.query<InitResponseType, string>({
      query: (slug: string) => ({
        url: BASE_LOAD_URL,
        params: {
          slug,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then((response) => {
          if (response.data.isNotFound) {
            dispatch(setError(new ApiError(404).toObject()));
          }

          dispatch(setFeatureDataList(response.data.featureList));
          const feature = diContainer.get<Feature>(DI_CONTAINER_TYPE.feature);
          feature.setList(response.data.featureList);

          const networkService = diContainer.get<NetworkServiceInterface>(DI_CONTAINER_TYPE.networkService);
          networkService.setAdditionalConfig({
            headers: {
              [HEADER_X_LANGUAGE]: response.data.languageData.current,
            },
          });

          const cookies = diContainer.get<Cookies>(DI_CONTAINER_TYPE.cookies);
          const expires = (new Date());
          expires.setMonth(expires.getMonth() + 1);
          cookies.getCookies().set(COOKIE_REQUEST_ID, response.data.requestId, {
            domain: response.data.domain,
            path: process.env.BASE_URL,
            expires,
          });
        }).catch(() => null);
      },
    }),
  }),
});

export { getApiBase };
